// extracted by mini-css-extract-plugin
module.exports = {"heading":"PageHeading_heading__1Tq-5","subPanel":"PageHeading_subPanel__Ewx2z"};